
export default {
  install(app) {
    let msgs = {
      not_yet_role: 'Tài khoản của bạn chưa được phân quyền!'
    };

    app.config.globalProperties.$msg = function(msg) {
      return msgs[msg] || (msg + ': nội dung chưa được xác định');
    }
  }
};
